import { Alert, Box } from "@mui/material";
import { useSelector } from "react-redux";

export function Messages() {
  const messages = useSelector((store: any) => store.messages);

  return (
    <Box sx={{ mb: 1 }}>
      {messages?.infoMessages?.map((message: string, i: number) => (
        <Alert sx={{ mb: 0.5 }} key={i} severity="warning">
          {message}
        </Alert>
      ))}
    </Box>
  );
}
